import React, {useEffect, useState} from "react";
import Typography from "@mui/material/Typography";

const TextWithAnimation = () => {
    const metersHeight = '1300';
    const duration = '1';
    // number displayed by component
    const [count, setCount] = useState('0');

    useEffect(() => {
        let start = 0;
        // first three numbers from props
        const end = parseInt(metersHeight.substring(0,3))
        // if zero, return
        if (start === end) return;

        // find duration per increment
        let totalMilSecDur = parseInt(duration);
        let incrementTime = (totalMilSecDur / end) * 1000;

        // timer increments start counter
        // then updates count
        // ends if start reaches end
        let timer = setInterval(() => {
            start += 1;
            setCount(String(start) + metersHeight.substring(3))
            if (start === end) clearInterval(timer)
        }, incrementTime);

        // dependency array
    }, [metersHeight, duration]);

    return <div className='about'>
        <Typography variant="h1" sx={{color: 'white', fontSize: '2rem', fontWeight: 'bold'}}>{count} m</Typography>
    </div>
}

export default TextWithAnimation;
